/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Packing_List_LinesInputs */

const en_inbound_field_packing_list_lines = /** @type {(inputs: Inbound_Field_Packing_List_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines of the packing list`)
};

/**
* | output |
* | --- |
* | "Lines of the packing list" |
*
* @param {Inbound_Field_Packing_List_LinesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_packing_list_lines = /** @type {((inputs?: Inbound_Field_Packing_List_LinesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Packing_List_LinesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_packing_list_lines(inputs)
});